angular.
module("dx.webapp.class").
factory("DxGroupConstructor", function GroupConstructorService() {
	"use strict";

	return function Group(group) {
		if (!(this instanceof Group)) {
			throw new Error("Constructor must be called with 'new'.");
		}

		this.id = 0;
		this.type = 0;
		this.title = "";
		this.about = "";
		this.students = [];
		this.studentCount = 0;
		this.isArchived = false;
		this.registrationCode = "";
		this.isRegistrationOpen = false;
		this.at = new Date();
		this.organizationId = 0;
		this.userId = 0;
		this.ltiOutcomeUrl = "";
		this.ltiOutcomeDataValuesAccepted = "";
		this.ltiCourseId = "";
		this.externallyManaged = false;

		angular.extend(this, group);
	};
});
